<template>
  <div :class="{ fullscreen: fullscreen }" class="tinymce-container" :style="{ width: containerWidth }">
    <textarea :id="tinymceId" class="tinymce-textarea" />
    <div class="editor-custom-btn-container">
      <editorImage color="#1890ff" class="editor-upload-btn" @successCBK="imageSuccessCBK" />
    </div>
  </div>
</template>

<script>
/**
 * docs:
 * https://panjiachen.github.io/vue-element-admin-site/feature/component/rich-editor.html#tinymce
 */
import editorImage from "./components/EditorImage";
import plugins from "./plugins";
import toolbar from "./toolbar";
import load from "./dynamicLoadScript";

// why use this cdn, detail see https://github.com/PanJiaChen/tinymce-all-in-one
const tinymceCDN = window.location.origin + '/tinymce/tinymce.min.js';

import uploadFileBlob from "@/config/uploadFileBlob";
import { dateFormatName } from "@/config/_filter";
export default {
  name: "Tinymce",
  components: { editorImage },
  props: {
    id: {
      type: String,
      default: function () {
        return (
          "vue-tinymce-" +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + "")
        );
      },
    },
    value: {
      type: String,
      default: "",
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return ['removeformat undo redo |  bullist numlist | outdent indent | forecolor | fullscreen code', 'bold italic blockquote | h2 p  media link | alignleft aligncenter alignright | fontsizeselect | fontselect'];
      },
    },
    menubar: {
      type: String,
      default: "file edit insert view format table",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360,
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto",
    },
  },
  data() {
    return {
      uploadFileTime: false,
      fileList: [],
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: "en",
        zh: "zh_CN",
        es: "es_MX",
        ja: "ja",
      },
    };
  },
  computed: {
    containerWidth() {
      const width = this.width;
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return `${width}px`;
      }
      return width;
    },
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || "")
        );
      }
    },
  },
  mounted() {
    this.init();
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce();
    }
  },
  deactivated() {
    this.destroyTinymce();
  },
  destroyed() {
    this.destroyTinymce();
  },
  methods: {
    init() {
      // dynamic load tinymce from cdn
      load(tinymceCDN, (err) => {
        if (err) {
          this.$message.error(err.message);
          return;
        }
        window.tinymce.baseURL = window.location.origin + '/tinymce';

        this.initTinymce();
      });

    },
    uploadFileBlob() { },
    initTinymce() {
      const _this = this;
      window.tinymce.init({
        external_plugins: {
          'mathjax': '/tinymce/plugins/mathjax/plugin.min.js',
          'kityformula-editor': '/tinymce/plugins/kityformula-editor/plugin.min.js',
        },

        mathjax: {
          lib: '/tinymce/plugins/mathjax/tex-mml-chtml.js'   //引用依赖
        },

        selector: `#${this.tinymceId}`,
        language: this.languageTypeList["zh"],
        fontsize_formats: "12px 14px 16px 18px 20px 22px 24px 26px 36px 48px 56px",
        font_formats: "Arial=arial; Arial Black=arial black;avant garde; Book Antiqua=book antiqua;palatino; Comic Sans MS=comic sans ms; Courier New=courier new;courier; Georgia=georgia; Helvetica=helvetica; Impact=impact;chicago; Symbol=symbol; Tahoma=tahoma;arial; sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms; Verdana=verdana;geneva; Webdings=webdings; Wingdings=wingdings", // 工具栏自定义字体选项
        height: this.height,
        body_class: "panel-body ",
        object_resizing: false,
        toolbar: toolbar,
        menubar: this.menubar,
        plugins: plugins,
        end_container_on_empty_block: true,
        powerpaste_word_import: "clean",
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: "square",
        advlist_number_styles: "default",
        imagetools_cors_hosts: ["www.tinymce.com", "codepen.io"],
        default_link_target: "_blank",
        paste_data_images: true,
        link_title: false,

        image_dimensions: true, //图片自适应
        codesample_global_prismjs: true,//允许调用用户自己引入的prism.js和prism.css
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on("NodeChange Change KeyUp SetContent", () => {
            this.hasChange = true;
            this.$emit("input", editor.getContent());
          });
        },
        setup(editor) {
          editor.on("FullscreenStateChanged", (e) => {
            _this.fullscreen = e.state;
          });

          editor.on('init', function () {
            this.getBody().style.fontSize = '16px';
            this.getBody().style.fontFamily = 'Arial';
          });
        },
        convert_urls: false,

        images_upload_handler(blobInfo, success, failure) {
          console.log(blobInfo, 123456)
          uploadFileBlob(
            blobInfo.blob(),
            "static/plat_exam/images/" + dateFormatName() + ".png",
            function (res) {
              console.log("上传成功");
              console.log(res);
              if (res.url) {
                success(res.url);
              } else {
                failure("上传失败");
              }
            }
          );

          /*.then((res) => {
              if (res.data.code == 0) {
                let file = res.data.data;
                success(file.filePath);
                return;
              }
              failure("上传失败");
            })
            .catch(() => {
              failure("上传出错");
            });*/

          /*
                if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index);
      }
 */
          /* const token = _this.$store.getters.token;
           getToken(token).then(response => {
             const url = response.data.qiniu_url;
             const formData = new FormData();
             formData.append('token', response.data.qiniu_token);
             formData.append('key', response.data.qiniu_key);
             formData.append('file', blobInfo.blob(), url);
             upload(formData).then(() => {
               success(url);
              progress(100);
            })
           }).catch(err => {
            failure('出现未知问题，刷新页面，或者联系程序员')
             console.log(err);
          });*/
        },
      });
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand("mceFullScreen");
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    imageSuccessCBK(arr) {
      arr.forEach((v) =>
        window.tinymce
          .get(this.tinymceId)
          .insertContent(`<img class="wscnph" src="${v.url}" >`)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}

.tinymce-container {
  ::v-deep {
    .mce-fullscreen {
      z-index: 10000;
    }
  }
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  z-index: 1;
}

.fullscreen .editor-custom-btn-container {
  z-index: 9999;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
  z-index: 10000;
}
</style>
